import React from 'react'
import ModelGroupItemContainer from './ModelGroupItemContainer'
import { modelShape } from '../../shapes'

const ModelGroupItem = ({ model }) => (
  <ModelGroupItemContainer model={model} data-test="component-model-group-item" />
)

ModelGroupItem.propTypes = {
  model: modelShape.isRequired
}

export default ModelGroupItem
